
import { computed, defineComponent, PropType, ref, watch } from "vue";
import InputNumber from "@/components/InputNumber.vue";
import InputToggle from "@/components/InputToggle.vue";
import InputToggleSwitch from "@/components/InputToggleSwitch.vue";
import InputCustomDropdown from "@/components/InputCustomDropdown.vue";

import { EditStore } from "@/stores";
import { IEditableObject, isImage, consts, isText } from "@/services/Models";

export default defineComponent({
  name: "EditCommandSerif",
  components: {
    InputNumber,
    InputToggle,
    InputToggleSwitch,
    InputCustomDropdown,
  },
  props: {
    editStore: { type: Object as PropType<EditStore> },
  },
  setup(props) {
    // サンプル集オープン
    const openExample = () => {
      let width = Math.min(consts.exampleWindowSize.width, window.innerWidth);
      let height = Math.min(
        consts.exampleWindowSize.height,
        window.innerHeight
      );
      window.open(
        "/sample/sample-attention.html",
        "",
        `width=${width},height=${height}`
      );
    };

    // フォントサイズ設定と最大フォントサイズに応じた行間設定処理
    const setFontSize = (value: string, object?: IEditableObject) => {
      let maxFontSize: string | undefined = props.editStore?.setFontSize(value);
      if (maxFontSize !== undefined) {
        let lineHeight =
          consts.fontSizeToLineHeight[
            maxFontSize as keyof typeof consts.fontSizeToLineHeight
          ];
        props.editStore?.lineHeight(lineHeight, object);
        selectedLineHeight.value = lineHeight;
      }
    };

    // 行間設定
    const setLineHeight = (value: number, object?: IEditableObject) => {
      if (selectedLineHeight.value !== value) {
        selectedLineHeight.value = value;
        props.editStore?.lineHeight(selectedLineHeight.value, object);
      }
    };

    const editingObject = ref<IEditableObject>();

    const startSize = consts.minFontSize;
    const fontSizes = ref(
      Array.from(Array(consts.maxFontSize - consts.minFontSize + 1).keys())
        .filter((x) => x % 2 == 0)
        .map((i) => ({
          name: `${startSize + i}px`,
          value: `${startSize + i}px`,
        }))
    );
    const selectedSize = ref(
      fontSizes.value.find((x) => x.value == consts.defaultFontSize)
    );

    const fontFores = ref(consts.foreColors);
    const selectedFontFore = ref(fontFores.value[0]);

    const fontBacks = ref(consts.backColors);
    const selectedFontBack = ref(fontBacks.value[0]);
    const isFamous = computed(
      () => props.editStore?.state.selectedFrame?.author.isFamous ?? false
    );

    const selectedLineHeight = ref(consts.defaultLineHeight);
    watch(
      () => props.editStore?.state.selectedObject,
      (obj) => {
        if (!obj) return;
        if (!isText(obj)) return;
        selectedLineHeight.value = obj.lineHeight;
      }
    );
    // セリフデータの選択状態
    const isTextDisabled = computed(
      () =>
        props.editStore?.state.selectedObject === undefined ||
        isImage(props.editStore?.state.selectedObject)
    );
    return {
      openExample,
      setFontSize,
      setLineHeight,
      fontSizes,
      selectedSize,
      fontBacks,
      selectedFontBack,
      fontFores,
      selectedFontFore,
      selectedLineHeight,
      isTextDisabled,
      isFamous,
      consts,
      editingObject,
    };
  },
});
